import React from 'react';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import Form from '../forms/FullScreenForm';
import { Link } from 'react-router-dom';
import { LOGIN_PATH } from '../../../constants/routes';

const ForgotPasswordForm = props => {
    return (
        <Form
            onSubmit={props.onSubmit}
            canSubmit={props.canSubmit}
            header={'Forgot Password'}
            body={
                <Input
                    label="Your Email"
                    name="email"
                    value={props.email}
                    onChange={props.onInput}
                    error={!!props.errorText}
                    errorMessage={props.errorText}
                />
            }
            withCancel={true}
            footer={
                <React.Fragment>
                    <Button loading={props.loading} inactive={!props.canSubmit} label="Reset Password" />
                    <Link className="ckp-forms-cancel" to={LOGIN_PATH}>
                        Cancel
                    </Link>
                </React.Fragment>
            }
        />
    );
};

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/components/application/authentication/ForgotPasswordForm.js